
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news/[newsId]",
      function () {
        return require("private-next-pages/news/[newsId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news/[newsId]"])
      });
    }
  